import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/number-list';
import ListGroupHeaderComponent from "./components/number-group-list-header";
import ViewComponent from './components/number-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from './components/number-form-new';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateNumberComponent from 'core/fields/custom/number/components/aggregate-number.jsx'
import normalizeNumber from "../../import/normalize/normalize-number";
import FieldNumberViewInImport from "../../import/view-in-preview/number-view-in-import";

export default class NumberCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);

        this.formulaCompatible = true;
    }

    /*listItemGroupFunction() {
        return i=>i.item.customFieldsData[this.customField.id]
    }*/

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !!customFieldsData[this.customField.id] ? customFieldsData[this.customField.id] : '';
    }

    getValue(item) {return item.customFieldsData[this.customField.id]}

    getAggregateClass() {
        return AggregateNumber
    }

    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return gd.const.aggregate.type.SUM
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => i.item.customFieldsData[this.customField.id] || 0
            ],
            directions: ['asc', sort]
        }
    }

    get ListComponent() {
        //return props => ListComponent(props, this.customField.id)
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    get AggregateComponent() {
        return AggregateNumberComponent.bind(null, this.getAggregateOptions(), this.customField.params);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeNumber(value);
    }

    getComponentViewInImport() {
        return FieldNumberViewInImport;
    }

}